module.exports = __webpack_public_path__ + "media/images/lb/615-bae65ff4a93191e4d8506a230bcf1231.svg";